import React from "react";
import { FaHeart } from "react-icons/fa";
import "./SoftCtaSection.css";

const SoftCtaSection = () => {
  return (
    <section className="_sCSec_p9Q_">
      <div className="_sCCont_q0R_">
        <div
          className="_cIWrap_r1S_"
          style={{ paddingBottom: "0", marginBottom: "0" }}
        >
          <FaHeart className="_cIcon_s2T_" />
        </div>
        <h2
          className="_cTitle_t3U_ _hTitle_s5E_ workflow-title"
          style={{ paddingTop: "0", marginTop: "0", marginBottom: "0" }}
        >
          Thanks for connecting with{" "}
          <span className="_hTxt_u4V_">Vanidya</span>!
        </h2>
        <p className="_cDesc_v5W_" style={{ paddingTop: "0", marginTop: "0" }}>
          We appreciate your interest in our services. Our team will review your
          message and reach out as soon as possible. Meanwhile, feel free to
          explore our other offerings or connect with us on social media!
        </p>
      </div>
    </section>
  );
};

export default SoftCtaSection;
